// src/components/Logo.tsx

const Logo = () => (
    <img src="/York-Neighbours-Website_Logo.png"></img>
)
export default Logo;
